<template>
  <div class="bg-lighter full-view">
    <b-container fluid>
      <b-row>
        <b-col offset-md="1" sm="12" md="11">
          <h1 class="mb-2 mt-5">Contact</h1>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col sm="12" md="10" offset-md="1">
          <b-row>
            <Contact
              name="Mads Albertsen"
              description="Professor MSO"
              company="Aalborg University"
              phone="22 93 21 91"
              email="ma@bio.aau.dk"
              image_name="pp3.jpeg"
            ></Contact>
            <Contact
              name="Anders Fomsgaard"
              description="Overlæge, Head of Virus R&D"
              company="Statens Serum Institut"
              phone="32 68 34 60"
              email="afo@ssi.dk"
              image_name="pp1.png"
            ></Contact>
            <Contact
              name="Morten Rasmussen"
              description="Seniorforsker"
              company="Statens Serum Institut"
              phone="32 68 89 80"
              email="mot@ssi.dk"
              image_name="pp2.jpg"
            ></Contact>
            <Contact
              name="Jannik Fonager"
              description="Seniorforsker"
              company="Statens Serum Institut"
              phone="32 68 36 21"
              email="fon@ssi.dk"
              image_name="pp4.png"
            ></Contact>

            
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Contact from "@/components/ContactPerson.vue";
export default {
  components: { Contact },
};
</script>